import { Link } from "react-router-dom";
import { ProfessionMasterPanel } from "../components/work-item-master/ProfessionMasterPanel.js";
import { useScreenView } from "../lib/analytics.js";

/**
 * 資格マスタ（組み込み3資格＋カスタム資格）の独立ページ。
 * 設計書: docs/design/profession-master-unification.md §6.2
 *
 * 旧: SettingsPage / WorkItemMasterPage の両方に ProfessionMasterPanel が
 * 直接マウントされていた（二重マウント）。これを解消し、このページに一本化する。
 */
export function ProfessionMasterPage() {
  useScreenView("profession_master");

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 6 }}>
        <Link to="/settings" style={{ color: "#0f766e", fontSize: 13, fontWeight: 700, textDecoration: "none" }}>
          ← 設定
        </Link>
      </div>
      <h1 style={{ fontSize: 20, fontWeight: 800, margin: "0 0 6px" }}>資格者・登録番号</h1>
      <p style={{ fontSize: 13, color: "#64748b", margin: "0 0 16px" }}>
        書類に印字する資格者・登録番号を管理します。
      </p>

      <div style={{ maxWidth: 860 }}>
        <ProfessionMasterPanel />
      </div>
    </div>
  );
}
